module.exports = __webpack_public_path__ + "ca9062e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/home/customers/mavoco.jpg
// module id = 762
// module chunks = 2